import { render, staticRenderFns } from "./About.vue?vue&type=template&id=23425a8d&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./About.vue?vue&type=style&index=0&id=23425a8d&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "23425a8d",
  "86cb35f4"
  
)

component.options.__file = "About.vue"
export default component.exports